import React, { useState } from 'react';
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import { connect } from 'react-redux';
import { tabChange } from './../../actions'
import StorefrontIcon from '@mui/icons-material/Storefront';
// import TelegramIcon from '@mui/icons-material/Telegram'; // آیکون تلگرام
// import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import { useNavigate } from 'react-router-dom'; // این رو اضافه کن
import HomeIcon from '@mui/icons-material/Home';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import { Snackbar, Alert, Backdrop } from '@mui/material';
import HeadsetMicIcon from '@mui/icons-material/HeadsetMic';

const Footer = (props) => {
    const [value, setValue] = useState(0);
    const [open, setOpen] = useState(false);

    const navigate = useNavigate(); // هوک برای navigation
    // const openTelegram = () => {
    //     window.open('https://t.me/silverhousenikoo', '_blank'); // باز کردن لینک در تب جدید
    // };
    const openStore = () => {
        window.open('https://noghrehome.com/', '_blank'); // باز کردن لینک در تب جدید
    };

    return (
        <footer>
            <BottomNavigation
                value={value}
                showLabels={true}
                onChange={(event, newValue) => {
                    setValue(newValue);
                    let tab = "";
                    switch (newValue) {
                        case 0:
                            tab = "home";
                            break;
                        // case 1:
                        //     tab = "ussd";
                        //     break;
                        default:
                            break;
                    }
                    props.dispatch(tabChange(tab));
                }}

            >
                <BottomNavigationAction label="خانه" icon={<HomeIcon />} onClick={() => navigate('/')} />
                <BottomNavigationAction label="فروشگاه حضوری" icon={<StorefrontIcon />} onClick={() => navigate('/about2')} />
                {/* <BottomNavigationAction label="فروشگاه اینترنتی" icon={<ShoppingCartIcon />} onClick={() => setOpen(true)} /> */}
                <BottomNavigationAction label="فروشگاه اینترنتی" icon={<ShoppingCartIcon />} onClick={openStore} />
                {/* <BottomNavigationAction label="Ussd" icon={<DialerSipIcon/>}/> */}
                {/* <BottomNavigationAction
                    label="تلگرام"
                    icon={<TelegramIcon/>}
                    onClick={openTelegram} // تابع باز کردن لینک
                /> */}
                <Backdrop
                    open={open}
                    onClick={() => setOpen(false)}
                    sx={{
                        zIndex: (theme) => theme.zIndex.snackbar - 1,
                        backgroundColor: 'rgba(0,0,0,0.3)',
                        backdropFilter: 'blur(6px)',
                    }}
                />
                <Snackbar
                    open={open}
                    autoHideDuration={3000}
                    onClose={() => setOpen(false)}
                    anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                    sx={{ top: '50%', transform: 'translateY(-50%)' }}
                >
                    <Alert severity="info" variant="filled" style={{ fontFamily: "inherit" }}>
                        سایت فروشگاه اینترنتی به زودی در دسترس قرار خواهد گرفت
                    </Alert>
                </Snackbar>
                <BottomNavigationAction label="پشتیبانی فروشگاه اینترنتی " icon={<HeadsetMicIcon />} onClick={() => navigate('/support-online')} sx={{
                    
                    '& .MuiBottomNavigationAction-label': {
                        fontSize: '0.75rem',  // اندازه فونت رو به دلخواه تغییر بده، مثلاً 0.75rem برای کوچک‌تر کردن
                    },
                }} />
            </BottomNavigation>
        </footer>
    )
        ;
};

const mapStateToProps = state => {
    return {
        expandMenuMode: state.expandMenuMode
    }
}

export default connect(mapStateToProps)(Footer);
